
import { Component, Vue } from 'vue-property-decorator'
import { hourTime, debounce } from '@/common'

interface Options {
  label: string
  value: string
  [propName: string]: any
}

interface TableData {
  subjectName: string
  actorApplication: string
  action: string
  resourceType: string
  resource: Array<string>
  resourceApplications: Array<string>
  actionScope: Array<string>
  eventTime: string
  [propName: string]: any
}

interface ActionsMap {
  [key: string]: string
}

const aDay = 86400000
const formatDays = (day: number) => {
  const end = new Date().getTime()
  const start = new Date().getTime() - aDay * day
  return [start, end]
}

const aHours = 3600000
const formatHours = (hour: number) => {
  const end = new Date().getTime()
  const start = new Date().getTime() - aHours * hour
  return [start, end]
}

const actionsMap: ActionsMap = {
  INSERT: '新增',
  UPDATE: '更新',
  DELETE: '删除',
  GRANT: '授权',
  RECYCLE: '回收',
  PUBLISH: '发布',
  WITHDRAW: '撤回',
  PLAY: '扮演',
}

const typesMap: ActionsMap = {
  ACCOUNT: '企业',
  DEPARTMENT: '部门',
  GROUP: '用户组',
  USER: '用户',
  POLICY: '策略',
  PRODUCT: '产品',
  MESSAGE: '消息',
}

const scopeMap: ActionsMap = {
  ACCOUNT: 'A',
  GROUP: 'G',
  USER: 'u',
}

const SEARCH_DELAY = 500

@Component
export default class AccessControl extends Vue {
  dateArr: Array<Number> = []
  time: string = 'unlimited'
  resourceType: Array<string> = []
  action: Array<string> = []
  keyword: string = ''
  timeFrom?: string | Number = ''
  timeTo?: string | Number = ''
  isloading: Boolean = false
  pagination = {
    total: 1000,
    currentPage: 1,
    size: 20,
  }
  resourceTypeOptions: Array<Options> = []
  actionOptions: Array<Options> = []
  timeOptions: Array<Options> = [
    { label: '不限', value: 'unlimited' },
    { label: '近1小时', value: '1hours' },
    { label: '近12小时', value: '12hours' },
    { label: '近1天', value: '1days' },
    { label: '近7天', value: '7days' },
    { label: '自定义', value: 'custom' },
  ]

  tableData: Array<TableData> = []

  debounceSearch = debounce(this.handleSearch, SEARCH_DELAY)

  pickerArrOptions = {
    shortcuts: [
      {
        text: '最近一周',
        onClick(picker: any) {
          // eslint-disable-next-line no-magic-numbers
          const date = formatDays(7)
          picker.$emit('pick', date)
        },
      },
      {
        text: '最近一个月',
        onClick(picker: any) {
          // eslint-disable-next-line no-magic-numbers
          const date = formatDays(30)
          picker.$emit('pick', date)
        },
      },
      {
        text: '最近三个月',
        onClick(picker: any) {
          // eslint-disable-next-line no-magic-numbers
          const date = formatDays(90)
          picker.$emit('pick', date)
        },
      },
    ],
  }

  get showDatePicker() {
    return this.time === 'custom'
  }

  mounted() {
    this.getList()
    this.handleSearch()
  }

  fomatDate() {
    if (this.time === 'unlimited') {
      this.timeFrom = ''
      this.timeTo = ''
    }
    if (this.time === '1hours') {
      const dateArr = formatHours(1)
      this.timeFrom = dateArr[0]
      this.timeTo = dateArr[1]
    }
    if (this.time === '12hours') {
      // eslint-disable-next-line no-magic-numbers
      const dateArr = formatHours(12)
      this.timeFrom = dateArr[0]
      this.timeTo = dateArr[1]
    }
    if (this.time === '1days') {
      const dateArr = formatDays(1)
      this.timeFrom = dateArr[0]
      this.timeTo = dateArr[1]
    }
    if (this.time === '7days') {
      // eslint-disable-next-line no-magic-numbers
      const dateArr = formatDays(7)
      this.timeFrom = dateArr[0]
      this.timeTo = dateArr[1]
    }
    if (this.time === 'custom') {
      this.initPicker()
      this.timeFrom = this.dateArr[0]
      this.timeTo = this.dateArr[1]
    }
    this.handleSearch()
  }

  async getAuditsList() {
    this.isloading = true
    const params = {
      keyword: this.keyword,
      action: this.action.join(','),
      resourceType: this.resourceType.join(','),
      timeFrom: this.timeFrom,
      timeTo: this.timeTo,
      index: this.pagination.currentPage,
      limit: this.pagination.size,
    }
    if (this.timeFrom === '') {
      delete params.timeFrom
      delete params.timeTo
    }
    const res = await this.$ucProxy({
      url: '/api/v1/audits',
      type: 'GET',
      data: params,
    })
    this.tableData = res.audits.map((o: any) => {
      o.action = actionsMap[o.action]
      o.resourceType = typesMap[o.resourceType]
      o.eventTime = hourTime(o.eventTime)
      o.actionScopeType = scopeMap[o.actionScopeType] || ''
      return o
    })
    this.pagination.total = res.pagination.total
    this.isloading = false
  }

  async getList() {
    const res = await this.$ucProxy({
      url: '/api/v1/audits/options',
      type: 'GET',
    })
    this.actionOptions = res.actionOptions.map((o: string) => {
      return {
        label: actionsMap[o],
        value: o,
      }
    })
    this.resourceTypeOptions = res.resourceTypeOptions.map((o: string) => {
      return {
        label: typesMap[o],
        value: o,
      }
    })
  }

  initPicker() {
    this.dateArr = formatDays(1)
  }

  handleCurrentChange(value: number) {
    this.pagination.currentPage = value
    this.getAuditsList()
  }

  handleChangePicker() {
    this.timeFrom = this.dateArr[0]
    this.timeTo = this.dateArr[1]
    this.handleSearch()
  }

  handleSearch() {
    this.pagination.currentPage = 1
    this.getAuditsList()
  }

  handleSizeChange(value: number) {
    this.pagination.size = value
    this.handleSearch()
  }

  handleInput() {
    this.debounceSearch()
  }
}
